import React, { createContext, useContext, useState, useCallback } from 'react';

const ResourceAllocationContext = createContext();

export const ResourceAllocationProvider = ({ children }) => {
  const [activeRAModal, setActiveRAModal] = useState(null);

  const openRAModal = useCallback((raData) => setActiveRAModal(raData), []);
  const closeRAModal = useCallback(() => setActiveRAModal(null), []);

  return (
    <ResourceAllocationContext.Provider
      value={{ activeRAModal, openRAModal, closeRAModal }}
    >
      {children}
    </ResourceAllocationContext.Provider>
  );
};

export const useResourceAllocation = () =>
  useContext(ResourceAllocationContext);
